import React from "react";
import { useArticleHeaderContext } from "../../hooks/articleHeaderContext";
export const FilterWrapper = ({ label, onChange, value, visible, children, }) => {
    const { loading } = useArticleHeaderContext();
    return (React.createElement("div", { className: `affectBar--filter ${loading ? "loading" : ""}` },
        React.createElement("div", { className: `affectBar--button ${value ? "small-label" : "large-label"}`, onClick: () => !loading && onChange(!visible), onKeyPress: () => !loading && onChange(!visible), role: "button", tabIndex: 0, "aria-disabled": loading },
            React.createElement("div", { className: "affectBar--button--inner" },
                React.createElement("span", { className: "affectBar--button--label" }, label),
                value && React.createElement("span", { className: "affectBar--value" }, value)),
            React.createElement("div", { className: "affectBar--filter--carat" },
                React.createElement("span", { className: "caret" }))),
        visible && children));
};
